import { aboutStats, principles, values } from "@/mocks/about";
import { siteInfo } from "@/mocks/site";

export default function AboutIntro() {
  return (
    <>
      <section className="bg-background-50 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
            <div className="lg:col-span-6">
              <p className="text-xs tracking-[0.25em] uppercase text-primary-600 mb-3">Who we are</p>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-tight">
                {siteInfo.name}是一条以保护投稿人为前提的信息通道
              </h2>
              <div className="mt-5 space-y-4 text-sm md:text-base leading-relaxed text-foreground-700">
                <p>
                  我们做的事情很朴素：让掌握信息的人，可以在不暴露身份的前提下把事实说出来。{siteInfo.name}
                  从{" "}
                  {siteInfo.foundedYear} 年开始运行，处理过职场用工、消费纠纷、公共安全等多个领域的信息。
                </p>
                <p>
                  与很多渠道不同，我们不要求注册、不收集手机号，也不设置必须实名的门槛。匿名投稿在这里不是附加选项，而是默认设置。
                </p>
                <p>
                  我们希望被记住的不是某个爆点，而是一套可靠的保密机制——它让每一次安全爆料都不必以牺牲个人安全为代价。
                </p>
              </div>

              <dl className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
                {aboutStats.map((item) => (
                  <div key={item.label} className="border-l-2 border-accent-400 pl-4">
                    <dt className="font-heading font-bold text-2xl text-primary-700">{item.value}</dt>
                    <dd className="mt-1 text-xs text-foreground-600">{item.label}</dd>
                  </div>
                ))}
              </dl>
            </div>

            <div className="lg:col-span-6">
              <div className="w-full h-[260px] md:h-[420px] rounded-lg overflow-hidden border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20dark%20green%20and%20warm%20stone%20composition%20of%20layered%20paper%20sheets%20and%20soft%20light%20rays%20suggesting%20confidential%20documents%20being%20protected%2C%20minimal%20editorial%20still%20life%2C%20muted%20amber%20highlight%2C%20soft%20shadows%2C%20clean%20negative%20space&width=1200&height=800&seq=baoliao51-about-01&orientation=landscape"
                  alt="被妥善保护的保密文件与信息层叠视觉"
                  title="爆料51 保密机制 隐私保护"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {values.map((item) => (
              <article key={item.title} className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-7">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 mb-5">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-3">{item.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-primary-950 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
            <div className="lg:col-span-4">
              <p className="text-xs tracking-[0.25em] uppercase text-accent-300 mb-3">信息处理原则</p>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 leading-tight">
                每条信息都按同一套规则处理
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-200">
                不因题材热门而放宽，也不因情况特殊而收紧。规则一致，你才能判断自己的信息会被怎样对待。
              </p>
            </div>
            <div className="lg:col-span-8">
              <ul className="divide-y divide-primary-800 border-y border-primary-800">
                {principles.map((item, index) => (
                  <li key={item} className="flex items-center gap-5 py-5">
                    <span className="shrink-0 font-heading text-sm font-semibold text-accent-400 w-8">
                      0{index + 1}
                    </span>
                    <span className="text-sm md:text-base text-background-100">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}